import React from 'react';
import PaymentPage from '../Tournaments/PaymentPage';

const RecordPaymentPage: React.FC = () => {
  return (
    <PaymentPage 
      paymentMode="offline"
      isRecordPayment={true}
    />
  );
};

export default RecordPaymentPage; 